<template>
    <div id="burger-menu" class="square bg-inverse cursor-pointer" :class="{open: isOpen}" @click="toggleMenu">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
    </div>
</template>

<script>
	export default {

		data: function () {
			return {
				isOpen: false,
			}
		},

		mounted: function () {
			bus.$on('burger-menu-open', () => {
				this.isOpen = true;
			});
			bus.$on('burger-menu-close', () => {
				this.isOpen = false;
				document.getElementById('burger-menu').style.display = 'none';
				setTimeout(() => {
					document.getElementById('burger-menu').style.display = 'block';
				}, 500);
			});
		},

		methods: {
			toggleMenu: function () {
				if (this.isOpen) {
					bus.$emit('burger-menu-close');
				} else {
					bus.$emit('burger-menu-open');
				}
			},
		}
	}
</script>

<style lang="scss">
    @import "./../../sass/variables";

    #burger-menu {
        width: 2.5rem;
        height: 2.5rem;
        position: relative;
        z-index: $zindex-sticky;

        span {
            display: block;
            position: absolute;
            height: 8%;
            width: 40%;
            background: white;
            left: 50%;
            transform: translate3d(-50%, -50%, 0);
            transition: .5s ease-in-out;

            &:nth-child(1) {
                top: 35%;
            }

            &:nth-child(2), &:nth-child(3) {
                top: 50%;
            }

            &:nth-child(4) {
                top: 65%;
            }
        }

        &.open span {

            &:nth-child(1), &:nth-child(4) {
                top: 50%;
                width: 0%;
                opacity: 0;
            }

            &:nth-child(2) {
                transform: translate3d(-50%, -50%, 0) rotate3d(0, 0, 1, 45deg);
            }

            &:nth-child(3) {
                transform: translate3d(-50%, -50%, 0) rotate3d(0, 0, 1, -45deg);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/BurgerMenu.vue